var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-block section-block--create-space"},[_c('oie-static-campaign')],1)}
var staticRenderFns = []

export { render, staticRenderFns }